module.exports = __webpack_public_path__ + "static/media/fa-brands-400.b7e790a3.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome/webfonts/fa-brands-400.woff
// module id = 870
// module chunks = 0